import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react"
import {
  Breadcrumb, Drawer, Dropdown,
  // FloatButton,
  notification, Space, Spin, Tabs, Typography
} from "antd";
import { useDispatch, useSelector } from "react-redux"
import { StoreState } from "src/store/configureStore"
import {
  changeTitleForwardClear,
  formulateCleanup,
  forwardPredListRequest,
  modelsConfigCleanup,
  modelsConfigListRequest,
} from "src/store/actions/formulate"
import {
  changeTitleClear,
  suggestedExperimentsClear,
} from "src/store/actions/suggestedExp"
import { AsyncStates } from "src/constants";
import {
  getPredictionRequest,
  inverseNotificationClick,
} from "src/store/actions/inverseModel"
import { workOrdersRequest } from "../../store/actions/workOrders"
import { ForwardModel } from "./ForwardModel"
import { CustomInsights } from "./CustomInsights/CustomInsights"
import useTranslate from "src/utils/useTranslate"
import {
  ArrowLeftOutlined, LoadingOutlined, MoreOutlined,
  // PartitionOutlined, 
  PlusOutlined
} from "@ant-design/icons"
import { filteredDisplayNamesRequest } from "src/store/actions/displayNames"
import { StyledPageHeader } from "src/styled_components/StyledPageHeader"
import { StyledCard } from "src/styled_components/StyledCard"
import { editWorkOrderClear } from "src/store/actions/workOrderDetails"
import {
  Route,
  Switch,
  useHistory,
  useParams,
  useLocation,
} from "react-router-dom"
import { trackEvent } from "src/analytics"
import { deleteEquationRequest, filterDataRequest } from "src/store/actions/customML"
// import { PolyGPT } from "../../modules/PolyGPT";
import InversePrediction from "./InversePrediction"
import { linkedFormulationsAiEngineClear } from "src/store/actions/common"
import InverseResults from "./InverseResults/InverseResults"
import { Filter } from "./InverseModelNew/catwise/inverse-model"
import InverseResult from "./InverseResults/InverseResult"
import { useQuery } from "src/utils/useQuery"
import { ForwardResults } from "./ForwardModel/ForwardResults"
import ForwardResult from "./ForwardModel/ForwardResult"
import "./AIEngine.scss"
import CustomMLWrapper from "./CustomML/CustomMlWrapper"
import { EquationModel } from "./CustomML/EquationModel"
import { useVariableValue } from "@devcycle/devcycle-react-sdk"
import StyledBadge from "src/styled_components/StyledBadge"
import { EquationModelHistory } from "./CustomML/EquationModelHistory";
import { StyledButton } from "src/styled_components/StyledButton";
import { Operations } from "./Operations/Operations";
import { Datasets } from "./Operations/Datasets";
import { Details } from "./Operations/Details";
import { ReactFlowProvider } from "@xyflow/react";
import { NewOperations } from "./Operations/NewOperations";
import { Position, ReactFlow, useEdgesState, useNodesState, useReactFlow } from '@xyflow/react';
import Dagre from '@dagrejs/dagre';
import { Analysis } from "./Operations/Analysis";
import { AnalysisDetails } from "./Operations/AnalysisDetails";
import { operationConfigsRequest } from "src/store/actions/operations";
import { useSync } from "src/mocks/useSync";
import BayesianOptimization from "./Extrapolation/BayesianOptimization/BeyesianOptimization";
import PredictionHistory from "./Extrapolation/PredictionHistory/PredictionHistory";
import PredictionHistoryDetails from "./Extrapolation/PredictionHistoryDetails/PredictionHistoryDetails";
type GettabsType = {
  [key: string]: string[]
}

export type FilterForward = {
  pageNum: number
  user_ids: string[]
  model_type: string[]
  status: string[]
  versions: string[]
}

type DataTypeKey = 'ingredients' | 'processing' | 'properties' | 'formulations';

const nodeDefaults = {
  sourcePosition: Position.Right,
  targetPosition: Position.Left,
};

const initialNodes = [
  { id: '1', position: { x: 0, y: 0 }, data: { label: 'Dataset' }, ...nodeDefaults },
  { id: '2', position: { x: 0, y: 100 }, data: { label: 'NIR Dataset' }, ...nodeDefaults },
  { id: '3', position: { x: 0, y: 100 }, data: { label: 'DWT Analysis' }, ...nodeDefaults },
  { id: '4', position: { x: 0, y: 100 }, data: { label: 'Peak Detection' }, ...nodeDefaults },
  { id: '5', position: { x: 100, y: 0 }, data: { label: 'Categorize' }, ...nodeDefaults },
  { id: '6', position: { x: 200, y: 0 }, data: { label: 'Combined Dataset' }, ...nodeDefaults },
  { id: '7', position: { x: 300, y: 0 }, data: { label: 'Model Creation' }, ...nodeDefaults },
  { id: '8', position: { x: 300, y: 0 }, data: { label: 'Model Selection' }, ...nodeDefaults },
  { id: '9', position: { x: 300, y: 0 }, data: { label: 'Evaluation Dataset' }, ...nodeDefaults },
  { id: '10', position: { x: 300, y: 0 }, data: { label: 'Predict' }, ...nodeDefaults },
  { id: '11', position: { x: 300, y: 0 }, data: { label: 'Evaluate' }, ...nodeDefaults },
];

const initialEdges = [
  { id: 'e1-5', source: '1', target: '5' },
  { id: 'e2-3', source: '2', target: '3' },
  { id: 'e3-4', source: '2', target: '4' },
  { id: 'e3-5', source: '3', target: '5' },
  { id: 'e4-5', source: '4', target: '5' },
  { id: 'e5-6', source: '5', target: '6' },
  { id: 'e6-8', source: '6', target: '7' },
  { id: 'e7-6', source: '7', target: '8' },
  { id: 'e8-9', source: '8', target: '9' },
  { id: 'e9-10', source: '9', target: '10' },
  { id: 'e10-11', source: '10', target: '11' },
];

const getLayoutedElements = (nodes, edges, options) => {
  const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: options.direction });

  edges.forEach((edge) => g.setEdge(edge.source, edge.target));
  nodes.forEach((node) =>
    g.setNode(node.id, {
      ...node,
      width: node.measured?.width ?? 0,
      height: node.measured?.height ?? 0,
    }),
  );

  Dagre.layout(g);

  return {
    nodes: nodes.map((node) => {
      const position = g.node(node.id);
      // We are shifting the dagre node position (anchor=center center) to the top left
      // so it matches the React Flow node anchor point (top left).
      const x = position.x - (node.measured?.width ?? 0) / 2;
      const y = position.y - (node.measured?.height ?? 0) / 2;

      return { ...node, position: { x, y } };
    }),
    edges,
  };
};

export const AIEngine = () => {
  const [t] = useTranslate()
  const dispatch = useDispatch()
  let query = useQuery()
  const configs = useSelector((state: StoreState) => state.configs.features)
  const ai_engine = useSelector((state: StoreState) => state.configs.ai_engine)
  const { current: currentProject,
    selectAllProjects 
  } = useSelector(
    (state: StoreState) => state.projects,
  )
  const operationDetailsData = useSelector((state: StoreState) => state.operations.operationDetailsData)

  const [experimentsCurrent, setExperimentsCurrent] = useState<any>(1)
  const [selectedObjective, setSelectedObjective] = useState("")
  const [inverseFilters, setInverseFilters] = useState<Filter | null>(null)
  const [forwardFilters, setForwardFilters] = useState<FilterForward | null>(
    null,
  )
  const [inverseCurrent, setInverseCurrent] = useState<any>(1)
  const [forwardCurrent, setForwardCurrent] = useState(1)
    
  // 
    const [trialInputsData, setTrialInputsData] = useState<Record<DataTypeKey, string[]>>({
          ingredients: [],
          processing: [],
          properties: [],
          formulations: [],
      });
    const [userIgnoredData, setUserIgnoredData] = useState<Record<DataTypeKey, string[]>>({
              ingredients: [],
              properties: [],
              processing: [],
              formulations: []
          })

   const [predHistExtrapolationTitle, setPredHistExtrapolationTitle] = useState("")

   const [bayesianPredHistoryPagination, setBayesianPredHistoryPagination] = useState<{current:number,pageSize:number}>({ current: 1, pageSize: 10 })
  const { state } = useLocation()
  const { push } = useHistory()
  const [tab, setTab] = useState<any>("properties_prediction")
  const [customMlDrawerVisible, setCustomMlDrawerVisible] = useState(false)
  const { configStatus } = useSelector((state: StoreState) => state.formulate)
  const inverseModel = useSelector((state: StoreState) => state.inverseModel)
  const {
    forwardPredList: { forwardData },
  } = useSelector((state: StoreState) => state.formulate)
  const { formulationfilterData } = useSelector(
    (state: StoreState) => state.CustomML,
  )
  const userId = useSelector(
    (state: StoreState) => state.login.loginResponse.user_id,
  )
  const eqModelList = useSelector(
    (state: StoreState) => state.CustomML.equationModelListData,
  )

  const { section, tab: _tab, id } = useParams<{
    section: string
    tab: string
    id: string
  }>()

  const predTitle = useMemo(() => eqModelList.find(model => model.run_id === id)?.title, [eqModelList, id])

  useEffect(() => {
    if (section === "operations")
      dispatch(operationConfigsRequest())
  }, [dispatch, section])

  useEffect(() => {
    setTab(_tab ?? "properties_prediction")
  }, [_tab])

  useEffect(() => {
    dispatch(
      workOrdersRequest({
        project_id: selectAllProjects ? null : currentProject,
        closed_stages: true,
      }),
    )
    dispatch(
      filteredDisplayNamesRequest(
        selectAllProjects ? {} : { project_id: currentProject },
      ),
    )
  }, [dispatch, currentProject, selectAllProjects, configs])

  useLayoutEffect(() => {
    dispatch(modelsConfigListRequest())
    return () => {
      dispatch(suggestedExperimentsClear())
      dispatch(formulateCleanup())
      dispatch(editWorkOrderClear())
      dispatch(linkedFormulationsAiEngineClear())
    }
  }, [dispatch])

  useEffect(() => {
    if (inverseModel.inverseNotificationClicked) {
      setTab("formulation_prediction")
      // setDrawerVisible(true)
      setTimeout(
        () => document.getElementById("inversepred-results")?.scrollIntoView(),
        300,
      )
    }
    return () => {
      dispatch(inverseNotificationClick(false))
    }
  }, [inverseModel.inverseNotificationClicked, dispatch])

  useEffect(() => {
    if (
      state &&
      Object.keys(state).includes("formulation_ids") &&
      _tab === "custom_ml_result" &&
      formulationfilterData.dataframe.length === 0
    ) {
      dispatch(
        filterDataRequest({
          payload: state,
          isTrialBased: true,
          redirect: false,
        }),
      )
    }
    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const showEquationModel = useVariableValue("equation-model", false)

  const gettabs: GettabsType = useMemo(
    () => ({
      predict: ["properties_prediction", "formulation_prediction"],
      history: ["properties_prediction", "formulation_prediction"],
      new_model: [
        ...(!Boolean(configs?.ai_engine_with_methods)
          ? [
            "custom_ml",
            ...(showEquationModel ? ["eq_model"] : []),
            ...(_tab === "custom_ml_result" ||
              (state && Object.keys(state).includes("formulation_ids"))
              ? ["custom_ml_result"]
              : []),
          ]
          : []),
      ],
      insights: [
        ...(Boolean(configs?.custom_insights) ? ["custom_insights"] : []),
      ],
      extrapolation:['bayesian_optimisation',"prediction_history"],
      operations: ["operations", "archived", "details", "datasets", "analysis"],
    }),
    [_tab, configs?.ai_engine_with_methods, configs?.custom_insights, showEquationModel, state],
  )

  useEffect(() => {
    if (!gettabs?.[section]?.includes(_tab)) {
      if (section === "new_model" && _tab === "model_analysis") {
        push("/ai-engine/model_analysis")
      } else if (section !== "operations") {
        push("/404")
      }
    }
  }, [gettabs, section, _tab, push])

  const companyId = useSelector(
    (state: StoreState) => state.login.loginResponse.company_id,
  )
  const getTranslatedKey = useCallback(
    (tabname: string) => {
      switch (tabname) {
        case "properties_prediction":
          return t("aiEngine.propertiesPrediction")
        case "formulation_prediction":
          return t("aiEngine.formulationsProcessingsPrediction")
        case "custom_ml":
          return t("aiEngine.tab.custom_ml")
        case "custom_ml_result":
          return "Custom ML Result"
        case "model_analysis":
          return t("aiEngine.tab.model_analysis")
        case "data_summary":
          return t("aiEngine.tab.data_summary")
        case "custom_insights":
          return t("aiEngine.tab.customInsights")
        case "predict":
          return t("aiEngine.predict")
        case "history":
          return t("aiEngine.predictionHistory")
        case "new_model":
          return t("navBar.menuItem.aiEngine.newModel")
        case "eq_model":
          return "Equation Model"
        case "insights":
          return "Insights"
        case "operations":
          return "Dimensionality Reduction"
        case "datasets":
          return "Datasets"
        case "analysis":
          return "Analysis"
        case "archived":
          return "Archived"
        case "details":
          return "Details"
        case "OPERATION_ID":
          return operationDetailsData?.name
        case "bayesian_optimisation":
            return "Bayesian Optimisation"
        case "prediction_history":
          return "Prediction History"  
        case "extrapolation":
            return"Extrapolation"    
        default:
          return tabname
      }
    },
    [operationDetailsData?.name, t],
  )
  const getTabTranslatedKey = useCallback(
    (tabname: string, section: string) => {
      switch (tabname) {
        case "properties_prediction":
          return t("aiEngine.propertiesPrediction")
        case "formulation_prediction":
          return t("aiEngine.formulationsProcessingsPrediction")
        case "custom_ml":
          return t("aiEngine.tab.custom_ml")
        case "custom_ml_result":
          return "Custom ML Result"
        case "model_analysis":
          return t("aiEngine.tab.model_analysis")
        case "data_summary":
          return t("aiEngine.tab.data_summary")
        case "custom_insights":
          return t("aiEngine.tab.customInsights")
        case "predict":
          return t("aiEngine.predict")
        case "history":
          return t("aiEngine.predictionHistory")
        case "new_model":
          return t("navBar.menuItem.aiEngine.newModel")
        case "eq_model":
          return "Equation Model"
        case "insights":
          return "Insights"
        case "operations":
          return "Operations"
        case "datasets":
          return "Datasets"
        case "analysis":
          return "Analysis"
        case "archived":
          return "Archived"
        case "details":
          return "Details"
        case "bayesian_optimisation":
            return "Bayesian Optimisation"
        case "prediction_history":
          return "Prediction History"
        default:
          if (section === "operations") {
            if (tabname) return operationDetailsData?.name
          }
          return tabname
      }
    },
    [operationDetailsData?.name, t],
  )
  const getBadge = useCallback(
    (tabname) => {
      if (section === "history") {
        if (tabname === "properties_prediction") {
          return ai_engine?.forward?.total_unread_count > 0 ? (
            <StyledBadge
              count={ai_engine?.forward?.total_unread_count}
              overflowCount={10}
              showZero={false}
            />
          ) : null
        }
        if (tabname === "formulation_prediction") {
          return ai_engine?.inverse?.total_unread_count > 0 ? (
            <StyledBadge
              count={ai_engine?.inverse?.total_unread_count}
              overflowCount={10}
              showZero={false}
            />
          ) : null
        }
      }
    },
    [
      ai_engine?.forward?.total_unread_count,
      ai_engine?.inverse?.total_unread_count,
      section,
    ],
  )

  const getTabs = useMemo(() => {
    let tabs = gettabs[section]
    if (section === "operations") {
      if (tabs.includes(_tab)) {
        tabs = [
          "operations",
          //  "archived"
        ]
      } else if ("new" === _tab) {
        tabs = []
      } else {
        tabs = ["details", "datasets", "analysis"]
      }
    }
    return tabs
      ?.filter((tabname) => {
        if (companyId === "COMP140MGVSEQE2023") {
          if (tabname === "formulation_prediction") {
            return false
          }
        }
        return true
      })
      ?.filter((tabname, _, tabs) => {
        return true
      })
      ?.map((tabname) => (
        <Tabs.TabPane
          tab={
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {getTranslatedKey(tabname)} {getBadge(tabname)}
              </span>
              {/* <GuideTooltip
											placement="bottomRight"
											module="properties_prediction"
										/> */}
            </div>
          }
          key={tabname}
        />
      ))
  }, [gettabs, section, _tab, companyId, getTranslatedKey, getBadge])

  const [breadCrumbItems, setBreadCrumbItems] = useState<any[]>([])

  const {
    expIdStatus,
    data: { experiments },
  } = useSelector((state: StoreState) => state.suggestedExp)

  const {
    forwardPredResult: { predictions: forwardPredResult = [] },
  } = useSelector((state: StoreState) => state.formulate)

  const { changeTitleResponse, changeTitleStatus } = useSelector(
    (state: StoreState) => state.suggestedExp,
  )

  const {
    changeTitleResponse: changeTitleResponseForward,
    changeTitleStatus: changeTitleStatusForward,
  } = useSelector((state: StoreState) => state.formulate)

  const predId = query?.get("predId")
  const extrapolationId = query?.get("extrapolationId")
  const predDetailsInverse = useMemo(() => {
    return inverseModel?.predictionIdsData?.data?.find(
      (pred: any) => pred.prediction_id === predId,
    )
  }, [inverseModel?.predictionIdsData?.data, predId])

  const predDetailsForward = useMemo(() => {
    return forwardPredResult?.find((pred: any) => pred.prediction_id === predId)
  }, [forwardPredResult, predId])

  useEffect(() => {
    setBreadCrumbItems([
      {
        title: getTranslatedKey(section),
      },
      { title: getTabTranslatedKey(_tab, section) },
      ...(predId
        ? [
          _tab === "formulation_prediction"
            ? {
              title: (
                <Typography.Text
                  style={{ width: 200 }}
                  ellipsis={{
                    tooltip:
                      changeTitleStatus === AsyncStates.SUCCESS
                        ? changeTitleResponse?.title
                        : predDetailsInverse?.title,
                  }}
                >
                  {changeTitleStatus === AsyncStates.SUCCESS
                    ? changeTitleResponse?.title
                    : predDetailsInverse?.title}
                </Typography.Text>
              ),
            }
            : {
              title: (
                <Typography.Text
                  style={{ width: 200 }}
                  ellipsis={{
                    tooltip:
                      changeTitleStatusForward === AsyncStates.SUCCESS
                        ? changeTitleResponseForward?.title
                        : predDetailsForward?.objective,
                  }}
                >
                  {changeTitleStatusForward === AsyncStates.SUCCESS
                    ? changeTitleResponseForward?.title
                    : predDetailsForward?.objective}
                </Typography.Text>
              ),
            },
        ]
        : []),
    ])
  }, [_tab, section, forwardData.predictions_list, getTranslatedKey, inverseModel.predictionIdsData.data, predId, expIdStatus, experiments, t, predDetailsForward, changeTitleStatus, changeTitleResponse?.title, predDetailsInverse?.title, changeTitleStatusForward, changeTitleResponseForward?.title, getTabTranslatedKey])

  useEffect(() => {
    return () => {
      dispatch(changeTitleClear())
      dispatch(changeTitleForwardClear())
    }
  }, [dispatch])

  useEffect(() => {
    if (section === "history" && _tab === "formulation_prediction") {
      dispatch(
        getPredictionRequest({
          pageNum: 1,
        }),
      )
    }
  }, [_tab, section, dispatch])

  useEffect(() => {
    if (section === "history" && _tab === "properties_prediction" && !predId) {
      dispatch(forwardPredListRequest({ pageNum: forwardCurrent }))
    }
  }, [_tab, section, dispatch, predId, forwardCurrent])

  useEffect(() => {
    return () => { dispatch(modelsConfigCleanup()) }
  }, [_tab, dispatch])

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const deleteHistory = () => {
    if (!selectedRowKeys.length) {
      notification.warning({
        message: "Please select a model.",
      });
      return;
    }
    dispatch(deleteEquationRequest({ run_ids: selectedRowKeys }))
  }

  const [openNewOperation, setOpenNewOperation] = useState(false);
  const [openNewAnalysis, setOpenNewAnalysis] = useState(false);

  const [open, setOpen] = useState(false);

  // const showDrawer = () => {
  //   setOpen(true);
  // };

  const onClose = () => {
    setOpen(false);
  };

  const { progressBar, pullSamples } = useSync()

  const { state: syncState }: any = useLocation()

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ syncState?.sync:", syncState?.sync)
    syncState?.sync && pullSamples()
  }, [pullSamples, syncState?.sync])

  useEffect(() => { return () => { window.history.replaceState(null, "", window.location.href) } }, [])

  useEffect(() => {
    setBayesianPredHistoryPagination({ current: 1, pageSize: 10 })
  },[_tab])

  return (
    <Space
      direction="vertical"
      size="large"
      className="gap-8"
      style={{ width: "100%" }}
    >
      <StyledPageHeader
        ghost={false}
        title={
          <Space direction="vertical">
            <Space style={{ display: 'flex', alignItems: 'center' }} >
              {((section === "history" && predId) || (id) || (section === "extrapolation" && extrapolationId)) && <ArrowLeftOutlined
                onClick={() => {
                  if (section === "operations") {
                    push(`/ai-engine/operations/operations`, { sync: true })
                  } else {
                    window.history.back()
                  }
                }}
                style={{
                  cursor: "pointer",
                  marginRight: 10,
                  outline: "none",
                }}
              />}
              <Typography.Title level={3} style={{ marginBottom: 0 }}>
                {predTitle || getTranslatedKey(section)}
              </Typography.Title>
            </Space>
            <Breadcrumb items={breadCrumbItems} />
          </Space>
        }
        extra={<>
          {(_tab === "eq_model" && !id) && (
            <Space>
              <StyledButton icon={<PlusOutlined />} size="large" type="primary" onClick={() => { push(`/ai-engine/new_model/eq_model/new`, { work_orders: [] }) }}>{t("navBar.menuItem.aiEngine.newModel")}</StyledButton>
              <Dropdown menu={{
                items: [
                  {
                    key: '1',
                    label: t("aiEngine.deleteModels"),
                  }],
                onClick: deleteHistory
              }}>
                <StyledButton icon={<MoreOutlined />} size="large" />
              </Dropdown>
            </Space>
          )}
          {(section === "operations") && (
            <Space>
              {_tab === "operations" && <StyledButton icon={<PlusOutlined />} size="large" type="primary" onClick={() => { setOpenNewOperation(true) }}>New Operation</StyledButton>}
              {id === "analysis" && <StyledButton icon={<PlusOutlined />} size="large" type="primary" onClick={() => { setOpenNewAnalysis(true) }}>New Analysis</StyledButton>}
            </Space>
          )}
        </>}
      />
      <StyledCard bodyStyle={{ padding: "0px" }}>
        <Spin
          indicator={<LoadingOutlined />}
          spinning={configStatus === AsyncStates.LOADING}
          tip={"Loading..."}
          style={{ height: "100%", width: "100%" }}
        >
          <>
            {section !== "operations" && getTabs?.length > 0 && !predId && (
              <Tabs
                onChange={(e) => {
                  trackEvent(userId, "AI Engine -> " + e + " was viewed", {
                    tab,
                    currentProject,
                  })
                  push(`/ai-engine/${section}/${e}`, state)
                }}
                activeKey={_tab}
                size="large"
                style={{ padding: "1rem", paddingTop: "0" }}
              >
                {getTabs}
              </Tabs>
            )}
            {(section === "operations" && ["operations", "archived"].includes(_tab)) && (
              <Tabs
                onChange={(e) => {
                  trackEvent(userId, "AI Engine -> " + e + " was viewed", {
                    tab,
                    currentProject,
                  })
                  push(`/ai-engine/${section}/${e}`, state)
                }}
                activeKey={_tab}
                size="large"
                style={{ padding: "1rem", paddingTop: "0" }}
              >
                {getTabs}
              </Tabs>
            )}
            {(section === "operations" && !gettabs?.[section]?.includes(_tab)) && (
              <Tabs
                onChange={(e) => {
                  trackEvent(userId, "AI Engine -> " + e + " was viewed", {
                    tab,
                    currentProject,
                  })
                  push(`/ai-engine/${section}/${_tab}/${e}`, state)
                }}
                activeKey={id}
                size="large"
                style={{ padding: "1rem", paddingTop: "0" }}
              >
                {getTabs}
              </Tabs>
            )}
          </>
          <Switch>
            <Route path="/ai-engine/predict/properties_prediction">
              <ForwardModel tab={tab} />
            </Route>
            <Route path="/ai-engine/predict/formulation_prediction">
              <InversePrediction
                tab={tab}
                selectedObjective={selectedObjective}
                setSelectedObjective={setSelectedObjective}
                experimentsCurrent={experimentsCurrent}
                setExperimentsCurrent={setExperimentsCurrent}
                inverseCurrent={inverseCurrent}
                inverseFilters={inverseFilters}
              />
            </Route>
            <Route path="/ai-engine/history/formulation_prediction" exact>
              {predId ? (
                <InverseResult
                  tab={tab}
                  selectedObjective={selectedObjective}
                  experimentsCurrent={experimentsCurrent}
                  setExperimentsCurrent={setExperimentsCurrent}
                  setSelectedObjective={setSelectedObjective}
                />
              ) : (
                <InverseResults
                  selectedObjective={selectedObjective}
                  inverseFilters={inverseFilters}
                  setInverseFilters={setInverseFilters}
                  inverseCurrent={inverseCurrent}
                  setInverseCurrent={setInverseCurrent}
                />
              )}
            </Route>

            <Route path="/ai-engine/history/properties_prediction" exact>
              {predId ? (
                <ForwardResult
                  tab={tab}
                  selectedObjective={selectedObjective}
                  experimentsCurrent={experimentsCurrent}
                  setExperimentsCurrent={setExperimentsCurrent}
                  setSelectedObjective={setSelectedObjective}
                />
              ) : (
                <ForwardResults
                  forwardFilters={forwardFilters}
                  setForwardFilters={setForwardFilters}
                  forwardCurrent={forwardCurrent}
                  setForwardCurrent={setForwardCurrent}
                />
              )}
            </Route>

            <Route path="/ai-engine/new_model/eq_model" exact>
              <EquationModelHistory
                customMlDrawerVisible={customMlDrawerVisible}
                setCustomMlDrawerVisible={setCustomMlDrawerVisible}
                onSelectChange={onSelectChange}
                selectedRowKeys={selectedRowKeys}
              />
            </Route>

            <Route path="/ai-engine/new_model/eq_model/:runid">
              <EquationModel
                customMlDrawerVisible={customMlDrawerVisible}
                setCustomMlDrawerVisible={setCustomMlDrawerVisible}
              />
            </Route>

            <Route path="/ai-engine/new_model/custom_ml">
              <CustomMLWrapper
                customMlDrawerVisible={customMlDrawerVisible}
                setCustomMlDrawerVisible={setCustomMlDrawerVisible}
              />
            </Route>
            {/* <Route path="/ai-engine/new_model/model_analysis">
              <ModelAnalysis />
            </Route> */}
            <Route path="/ai-engine/insights/custom_insights">
              <CustomInsights />
            </Route>
            <Route path="/ai-engine/operations/operations" exact>
              <ReactFlowProvider>
                <Operations open={openNewOperation} setOpen={(open: boolean) => { setOpenNewOperation(open) }} />
              </ReactFlowProvider>
            </Route>
            <Route path="/ai-engine/operations/new" exact>
              <ReactFlowProvider>
                <NewOperations />
              </ReactFlowProvider>
            </Route>
            <Route path="/ai-engine/operations/:opid/details">
              <Details />
            </Route>
            <Route path="/ai-engine/operations/:opid/datasets">
              <Datasets />
            </Route>
            <Route path="/ai-engine/operations/:opid/analysis" exact>
              <Analysis open={openNewAnalysis} setOpen={(open: boolean) => { setOpenNewAnalysis(open) }} />
            </Route>
            <Route path="/ai-engine/operations/:opid/analysis/:anid/:step">
              <AnalysisDetails />
            </Route>
            <Route path="/ai-engine/extrapolation/bayesian_optimisation" exact>
              <BayesianOptimization trialInputsData={trialInputsData} setTrialInputsData={setTrialInputsData}  userIgnoredData={userIgnoredData} setUserIgnoredData={setUserIgnoredData} />
           </Route>
             <Route path="/ai-engine/extrapolation/prediction_history" exact>
             {extrapolationId ? <PredictionHistoryDetails predHistExtrapolationTitle={predHistExtrapolationTitle} trialInputsData={trialInputsData} setTrialInputsData={setTrialInputsData} userIgnoredData={userIgnoredData} setUserIgnoredData={setUserIgnoredData}/> :
               <PredictionHistory pagination={bayesianPredHistoryPagination} setPagination={setBayesianPredHistoryPagination}   setPredHistExtrapolationTitle={setPredHistExtrapolationTitle}/>}
            </Route>
          </Switch>
        </Spin>
      </StyledCard>
      {/* {section === "operations" && id && <FloatButton shape="square" type="primary" onClick={showDrawer} style={{ insetInlineStart: 128, width: 144 }} description={<Space><PartitionOutlined style={{ fontSize: 16 }} /><span>Workflow</span></Space>} />} */}
      <Drawer height={280} placement="bottom" title="Workflow" onClose={onClose} open={open}>
        <ReactFlowProvider>
          <Workflow />
        </ReactFlowProvider>
      </Drawer>
      {progressBar}
    </Space >
  )
}

const Workflow = () => {
  const { fitView } = useReactFlow();
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  const layouted = useMemo(() => getLayoutedElements(nodes, edges, { direction: "LR" }), [edges, nodes]);

  useEffect(() => {
    window.requestAnimationFrame(() => {
      fitView();
    });
  }, [fitView, nodes, edges])
  return (
    <div style={{ width: "100%", height: 120 }}>
      <ReactFlow nodes={layouted.nodes} edges={layouted.edges} fitView onNodesChange={onNodesChange} onEdgesChange={onEdgesChange} />
    </div>
  )
}
